import React, { ComponentType } from "react"
import { compose } from "@reduxjs/toolkit"
import { useTranslation } from "react-i18next"
import { Grid, DialogContent } from "@mui/material"

import i18n from "config/i18n"
import { useAppDispatch } from "redux/hooks"
import {
  withModalStep,
  withModalDebt,
  withModalPaymentAmount,
} from "hocs/features"
import { closeDialog } from "redux/features/dialog/dialogSlice"
import PollingService from "redux/api/pollingService"
import { showAlert } from "redux/features/notice/noticeSlice"
import {
  StepperComponent as Stepper,
  StepComponent as Step,
  StepContentComponent as StepContent,
} from "components/ui/Stepper"
import Close from "components/ui/ModalClose"
import NewTransfer from "components/SepaPayment/Pay/Transfer"
import { PAYMENT_STEP_TRANSFER } from "config"
import { DebtModalType, DebtType } from "types"

type Props = DebtModalType & {
  amount: number
  debt: DebtType
  step: number
}

const SepaPaymentPayModal = ({
  debt,
  amount,
  step = PAYMENT_STEP_TRANSFER,
}: Props) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const handleClose = () => {
    if (PollingService.isPolling()) {
      return dispatch(
        showAlert({
          message: i18n.t("common.request_in_progress"),
        }),
      )
    }
    dispatch(closeDialog())
  }

  const STEPS = [
    {
      label: PAYMENT_STEP_TRANSFER,
      title: t("features.payment.form.title"),
      component: <NewTransfer amount={amount} debt={debt} />,
    },
  ]

  return (
    <DialogContent>
      <Close onClick={handleClose} />
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Stepper activeStep={step} orientation="vertical">
          {STEPS.map(({ component }, index) => (
            <Step key={index}>
              <StepContent>{component}</StepContent>
            </Step>
          ))}
        </Stepper>
      </Grid>
    </DialogContent>
  )
}

export default compose<ComponentType>(
  withModalStep,
  withModalDebt,
  withModalPaymentAmount,
)(SepaPaymentPayModal)
